import React, { useState, useEffect } from 'react';
import SideMenuBar from '../../components/sideMenuBar';
import { useNavigate } from 'react-router-dom';
import { ACTIONS, KEYS, URLS } from '../../_config';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import Icon from '../../components/icons';
import moment from 'moment';
import { useUserApi } from '../../store/api/hooks/userApiHook';
import Spinner from '../../components/iconSvgs/spinner';
import { ActivetabProps } from '../../_config/interfaces/interfaces';
import { toast } from 'react-hot-toast';
import {getToken } from '../../store/api/callApi';

const PersonalInformation: React.FC<ActivetabProps> = ({ activeTab }) => {
    const [filterValue, setFilterValue] = useState<any>({});
    const [isOnSubmitLoading, setIsOnSubmitLoading] = useState<boolean>(false);
    const [showPassword, setShowPassword] = useState(false);
    const [cshowPassword, setCShowPassword] = useState(false);

    const navigate = useNavigate();
    const userAPI: any = useUserApi();

    const { register, formState: { errors }, handleSubmit, } = useForm<any>();
    const { register: resetRegister, formState: { errors: errorsReset }, 
    handleSubmit: resetHandleSubmit, watch, reset: resetPsw } = useForm<any>();
    const password = watch("password");

    useEffect(() => {
        setIsOnSubmitLoading(true);
        setTimeout(() => {
            setIsOnSubmitLoading(false);
        }, 2000);
    }, []);

    const handleApplyFilter = (filterData: any) => {
        setFilterValue(filterData);
    };

    const handleClearFilter = () => {
        setFilterValue(null);
    };

    const togglePassword = () => {
        setShowPassword(!showPassword);
    };

    const toggleCPassword = () => {
        setCShowPassword(!cshowPassword);
    };

    const resetPassword = (data: any) => {
        setIsOnSubmitLoading(true);
        const param = {
            token: getToken(),
            new_password: data.password,
        }
        try {
            setTimeout(() => {
                userAPI.resetPassword(param, (msg: any, resp: any) => {
                    if (resp?.code === 201 || resp?.code === 200) {
                        toast.success(resp?.message);
                    } else {
                        toast.error(resp?.message);
                    }
                    resetPsw();
                }, (error: any, resp: any) => {
                    // console.log('error =>', error, resp);
                    if (resp?.detail?.code === 400 || resp?.detail) {
                        toast.error(resp?.detail);
                    } else {
                        toast.error("Something went wrong");
                    }
                    resetPsw();
                });
                setIsOnSubmitLoading(false);
            }, 3000)
        } catch (e) {
            // console.log('error =>', e);
            setIsOnSubmitLoading(false);
            resetPsw();
        }
    };


    return (
        <div className="mt-6">
            {isOnSubmitLoading && (
                <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                    <Spinner className="self-center z-50" />
                </div>
            )}
            <h2 className="text-gray-500 text-xl font-semibold">Personal Information</h2>
            <div className="w-96 mobile-full-width">
                <form className="mt-4">
                    <div className="mb-4 relative">
                        <input type="text" className="mt-1 block w-full border border-gray-300 rounded-md p-2" placeholder="Enter your name" />
                        <Icon name="user" size={20} className="absolute right-3 top-[20px] transform -translate-y-1/2 text-gray-400" />

                    </div>
                    <div className="flex mb-3">
                        <button
                            type="submit"
                            className="flex w-32 justify-center rounded-md bg-blue-500 p-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
                        >
                            Update
                        </button>
                        <button
                            type="submit"
                            className="flex w-32 justify-center rounded-md bg-red-500 ml-2 p-3 text-sm font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>

            <div className='mt-[4.5rem]'>
                <hr className='border-t border-gray-300' />
                <h2 className="text-gray-500 text-xl font-semibold">Change Password</h2>
                <div className="mt-5 w-96 mobile-full-width">
                    <form onSubmit={resetHandleSubmit(resetPassword)}>
                        <div className="mb-4">
                            <div className="mt-2 relative">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    {...resetRegister("password", { required: true })}
                                    autoComplete="current-password" placeholder='New Password'
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-900 outline outline-1 -outline-offset-1 ${errorsReset.password ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                />
                                <Icon name={showPassword ? 'eye' : 'eye-off'} size={20} className="absolute right-3 top-[25px] transform -translate-y-1/2 text-gray-400" onClick={togglePassword} />
                            </div>
                        </div>

                        <div className="mb-4">
                            <div className="mt-2 relative">
                                <input
                                    type={cshowPassword ? 'text' : 'password'}
                                    {...resetRegister("confirmPassword", {
                                        required: "Confirm Password is required",
                                        validate: value => value === password || "Passwords do not match",
                                    })}
                                    autoComplete="current-password" placeholder='Confirm Password'
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-900 outline outline-1 -outline-offset-1 ${errorsReset.cpassword ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                />
                                <Icon name={cshowPassword ? 'eye' : 'eye-off'} size={20} className="absolute right-3 top-[25px] transform -translate-y-1/2 text-gray-400" onClick={toggleCPassword} />
                            </div>
                            {errorsReset.confirmPassword && (
                                <span className="text-red-500 text-xs">Passwords do not match</span>
                            )}
                        </div>


                        <div className='mb-5'>
                            <button
                                type="submit"
                                className="flex w-32  justify-center rounded-md bg-blue-500 p-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            >Submit</button>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    );
}

export default PersonalInformation;